// @generated by protoc-gen-connect-es v0.10.0 with parameter "target=ts"
// @generated from file src/protos/learning_management/lms.teacher.apis.proto (package geneo.lms.teacher.apis, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { FetchTeacherBannersRequest, FetchTeacherBannersResponse, FetchTeacherBannersV2Request, FetchTeacherBannersV2Response } from "./lms.teacher.apis_pb";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service geneo.lms.teacher.apis.LmsTeacherAPIServiceV1
 */
export const LmsTeacherAPIServiceV1 = {
  typeName: "geneo.lms.teacher.apis.LmsTeacherAPIServiceV1",
  methods: {
    /**
     * @generated from rpc geneo.lms.teacher.apis.LmsTeacherAPIServiceV1.fetchTeacherBanners
     */
    fetchTeacherBanners: {
      name: "fetchTeacherBanners",
      I: FetchTeacherBannersRequest,
      O: FetchTeacherBannersResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

/**
 * V2 Service for Teacher Banners
 *
 * @generated from service geneo.lms.teacher.apis.LmsTeacherAPIServiceV2
 */
export const LmsTeacherAPIServiceV2 = {
  typeName: "geneo.lms.teacher.apis.LmsTeacherAPIServiceV2",
  methods: {
    /**
     * @generated from rpc geneo.lms.teacher.apis.LmsTeacherAPIServiceV2.fetchTeacherBanners
     */
    fetchTeacherBanners: {
      name: "fetchTeacherBanners",
      I: FetchTeacherBannersV2Request,
      O: FetchTeacherBannersV2Response,
      kind: MethodKind.Unary,
    },
  }
} as const;

